import { ButtonHTMLAttributes, FC } from 'react'

import { IconName, IconV2 } from '../../../Icon'

import { s } from './styles'

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  icon: IconName
}

export const PaginationArrow: FC<ButtonProps> = (props) => {
  const { icon, ...rest } = props

  return <s.Button {...rest}>{icon && <IconV2 name={icon} size={10} />}</s.Button>
}
